import { inject } from '@angular/core';
import { InvoiceBulkDownloadApiService } from '@aiwyn/gql-api/src/services/secure/v1/invoice/bulk-download-api.service';
import { injectMutation } from '@tanstack/angular-query-experimental';

function bulkDownload() {
  const api = inject(InvoiceBulkDownloadApiService);

  return injectMutation(() => ({
    mutationFn: (invoiceIds: number[]) =>
      api.bulkDownloadInvoices({ bulkDownloadInvoicesRequest: { invoiceIds } }).then((res) => res.response),
  }));
}

export const invoicesQueries = { bulkDownload };
